"use strict";
module.exports = {
  "add": {
    title: "Hinzufügen",
    icon: "fa-plus"
  },
  "remove": {
    title: "Entfernen",
    icon: "fa-minus"
  },
  "thesaurus": {
    title: "Thesaurus",
    icon: "fa-book"
  },
  "lodentries": {
    title: "LOD-Einträge",
    icon: "fa-external-link"
  },
  "comments": {
    title: "Kommentare",
    icon: "fa-comment"
  },
  "references": {
    title: "Literatur",
    icon: "fa-bars"
  },
  "remarkable": {
    title: "Bemerkenswert",
    icon: "fa-star"
  },
  "unconfirmed": {
    title: "Unsicherheit",
    icon: "fa-question"
  },
  "search": {
    title: "Suchen",
    icon: "fa-search"
  },
  "primary": {
    title: "Primärbild",
    icon: "fa-star"
  },
  "outdated": {
    title: "Alte Aufnahme",
    icon: "fa-clock-o"
  },
  "hidden": {
    title: "Nicht anzeigen",
    icon: "fa-ban"
  },
  "detail": {
    title: "Detailbild",
    icon: "fa-cube"
  },
  "total": {
    title: "Gesamtbild",
    icon: "fa-cubes"
  },
  "copyall": {
    title: "Alle Felder aus Ensemble übernehmen",
    icon: "fa-copy"
  },
  "copyempty": {
    title: "Leere Felder aus Ensemble übernehmen",
    icon: "fa-copy"
  }
};
